import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useImagesStore = defineStore('images', () => {
  const viewMode = ref('grid')
  const thumbnailSize = ref('M')
  const sortBy = ref('name')
  const sortOrder = ref('asc')
  const itemsPerPage = ref(200)

  const thumbnailSizeMap = { S: 80, M: 120, L: 160, XL: 220 }
  const thumbnailPx = computed(() => thumbnailSizeMap[thumbnailSize.value] || 120)

  function toggleSortOrder() {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  }

  function resetPreferences() {
    viewMode.value = 'grid'
    thumbnailSize.value = 'M'
    sortBy.value = 'name'
    sortOrder.value = 'asc'
    itemsPerPage.value = 200
  }

  return {
    viewMode, thumbnailSize, thumbnailPx, sortBy, sortOrder,
    itemsPerPage, toggleSortOrder, resetPreferences
  }
}, {
  persist: {
    key: 'ai-database-images',
    storage: sessionStorage,
    paths: ['viewMode', 'thumbnailSize', 'sortBy', 'sortOrder', 'itemsPerPage']
  }
})
